import { ConfigQuery } from '../generated/operations';
import { UserSettings } from '../types/UserSettings';
import { getCountryCodeOrDefault, getCountryData, getLocale } from './parseSettingsFromUrl';
import { parseUrl } from './parseUrl';

function mapCodesToIso(country: string) {
  const upperCased = country.toUpperCase();
  if (upperCased === 'UK') {
    return 'GB'
  }
  return upperCased;
}

export function parseSettingsFromUrlOnBelimoHost(
  config: ConfigQuery,
  global: Window = window,
): UserSettings | null {

  const {location} = global;
  const url = parseUrl(location.toString());

  if (!url) {
    return null;
  }

  const [,country = null, language = null] = url.pathname.split('/');

  if (country === null || language === null) {
    return null;
  }
  const countryCodeFromUrl = getCountryCodeOrDefault(mapCodesToIso(country));
  const {code: countryCode, data: countryData} = getCountryData(countryCodeFromUrl, config);

  if (!countryData) {
    return null;
  }

  return {
    shoppingCenter: countryData.shoppingCenter || null,
    currentCountry: countryCode,
    currentRegion: countryData.region,
    currentLocale: getLocale(countryData, language),
  }

}
